import React, { useState} from "react";
import {DataTableColumn} from "../../../../../components/common/datatable/DataTableTypes";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import {DataTable} from "../../../../../components/common/datatable/DataTable";
import {useSearchTeamsQuery} from "../../../../user/teams/teamsApi";
import Modal from "../../../../../components/common/form/Modal";
import {handleRTKQuery} from "../../../../../helpers/utils/RtkQueryUtils";
import {useUpdateProductTargetTeamIdMutation} from "../../../productsApi";
import InputField from "../../../../../components/common/form/InputField";
import {FaSearch} from "react-icons/fa";


interface AssignToFormProps {
    show: boolean;
    setShow: (show: boolean) => void;
    productId: any;
    assignedToProps: string | null;
    isHoa?: boolean;
    tenant: string;
}

const TeamListModal: React.FC<AssignToFormProps> = ({
                                                        show,
                                                        setShow,
                                                        productId,
                                                        assignedToProps,
                                                        isHoa,
                                                        tenant
                                                    }) => {
    const [selectedId, setSelectedId] = useState<any>(null);
    const [updateAssignmentInfoApi] = useUpdateProductTargetTeamIdMutation();
    const [name, setName] = useState("");
    const iconButtonStyle = "fa cursor-pointer text-surface-3 absolute left-auto right-5 top-6";

    const handleIconClick = () => {
        const inputElement = document.getElementById("nameInput") as HTMLInputElement;
        if (inputElement) {
            alert(`Entered Name: ${inputElement.value}`);
        }
    };

    const handleSubmit = async () => {
        if (selectedId) {
            await handleRTKQuery(() => {
                updateAssignmentInfoApi({productId: productId, teamId: selectedId});
            }, () => {
                setShow(false);
            });
        }
    }
    const handleRowSelection = (selectedRows: any, row: any) => {
        setSelectedId(row.original.team.id);
    };

    const columns: DataTableColumn[] = [


        {
            label: "Name",
            accessor: "team.teamName",
        },
        {
            label: "", accessor: "team.id", canSort: false,
            cell: () => {
                return <><span/></>
            }
        },
    ]

    return (

        <Modal
            title={"Assign to Team"}
            show={show}
            setShow={setShow}
            hoa={isHoa}
            className="w-2/4 bg-text-0 rounded-lg shadow-lg"
            fields={
                <>
                    <div
                        className="modal-body max-h-[calc(100vh-200px)] overflow-auto [-ms-overflow-style:none] [scrollbar-width:none]">
                        <InputField
                            name={"name"}
                            label="Name"
                            value={name}
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter Name..."
                            required={true}
                            hideLabel
                            className="mb-3"
                            inputIcon={
                                <FaSearch className={iconButtonStyle}
                                          title={"Add Note"} onClick={handleIconClick}/>}
                        />
                        <DataTable
                            columns={columns}
                            actions={{
                                fetchAction: useSearchTeamsQuery,
                            }}
                            defaultFilter={{
                                pageNumber: 0,
                                pageSize: 8,
                                tenant: tenant
                            }}
                            defaultSortOptions={{
                                accessor: "creationDate",
                                direction: "desc"
                            }}
                            rowSelectionOptions={{
                                enableRowSelection: true,
                                onSelectionChange: handleRowSelection,
                                enableMultiRowSelection: false,
                                rowIdAccessor: 'team.id'
                            }}
                            classname={`${isHoa ? 'bg-highlight-1 text-text-0' : 'bg-highlight-5 text-text-0 border-highlight-0'}`}
                            renderOptions={{skipUserSettingRender: true, skipFilterButtonRender: true}}
                            appendFilterToUrl={false}

                        />


                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "cancel",
                                    },
                                    buttonType: "button",
                                },
                                {
                                    buttonProps: {
                                        btnText: "Assign",
                                        type: "submit",
                                        onClick: handleSubmit,
                                        isHoa: isHoa
                                    },
                                    buttonType: "button",
                                },
                            ]}
                            align="end"
                            gap={2}
                        />

                    </div>
                </>
            }
        />

    );
};

export default TeamListModal;